module.exports = __webpack_public_path__ + "static/img/p5.6d8a93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word-game/p5.png
// module id = tKRA
// module chunks = 0